/*
 * sht-flip-countdown
 * Drop-in replacement for the built-in flip countdown.
 * Uses a correctly aligned 4-face split-flap so the two digit halves line up
 * perfectly during the fold — no more ghost/half digit on the seconds.
 * Timezone handling mirrors the original component.
 */
(function () {
  if (window.customElements && customElements.get('sht-flip-countdown')) return;

  var UNITS = ['days', 'hours', 'minutes', 'seconds'];
  var FLIP_MS = 820;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  class FlipCountdown extends HTMLElement {
    connectedCallback() {
      this.isExpired = this.getAttribute('data-is-expired') === 'true';
      this.hideOnEnd = this.getAttribute('data-hide-on-end') === 'true';
      this.counterEl = this.querySelector('.js-counter');
      this.msgEl = this.querySelector('.js-counter-message');

      this.cards = {};
      var self = this;
      UNITS.forEach(function (u) {
        var wrap = self.querySelector('.js-counter-' + u);
        if (!wrap) return;
        var card = wrap.querySelector('.flip-card');
        if (!card) return;
        self.cards[u] = {
          card: card,
          cur: card.getAttribute('data-value') || '00',
          top: card.querySelector('.flip-card__top span'),
          bottom: card.querySelector('.flip-card__bottom span'),
          ftop: card.querySelector('.flip-card__flip-top span'),
          fbottom: card.querySelector('.flip-card__flip-bottom span')
        };
      });

      if (this.isExpired) return;

      this.tzOffset = this.getAttribute('data-time-zone-offset') || '+0000';
      var date = this.getAttribute('data-end-date');
      var time = this.getAttribute('data-end-time') || '23:59:00';
      if (time.length === 5) time += ':00';
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date || '')) {
        var n = new Date();
        date = n.getFullYear() + '-' + pad(n.getMonth() + 1) + '-' + pad(n.getDate());
      }

      var sign = this.tzOffset.charAt(0) === '-' ? -1 : 1;
      var offMs =
        sign *
        (parseInt(this.tzOffset.substr(1, 2), 10) * 60 +
          parseInt(this.tzOffset.substr(3, 2), 10)) *
        60000;

      var wallUTC = Date.parse(date + 'T' + time + 'Z');
      this.target = isNaN(wallUTC) ? null : wallUTC - offMs;
      if (this.target === null) return;

      this.tick();
      this.interval = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    tick() {
      var rem = this.target - Date.now();
      if (rem <= 0) {
        if (this.interval) clearInterval(this.interval);
        this.apply('days', '00');
        this.apply('hours', '00');
        this.apply('minutes', '00');
        this.apply('seconds', '00');
        if (this.msgEl && this.msgEl.innerHTML.trim() !== '') {
          this.msgEl.classList.remove('d-none');
        }
        if (this.hideOnEnd && this.counterEl) {
          this.counterEl.classList.add('d-none-important');
        }
        return;
      }
      this.apply('days', pad(Math.floor(rem / 86400000)));
      this.apply('hours', pad(Math.floor((rem % 86400000) / 3600000)));
      this.apply('minutes', pad(Math.floor((rem % 3600000) / 60000)));
      this.apply('seconds', pad(Math.floor((rem % 60000) / 1000)));
    }

    apply(u, val) {
      var c = this.cards[u];
      if (!c || c.cur === val) return;
      var old = c.cur;

      if (c.top) c.top.textContent = val;
      if (c.bottom) c.bottom.textContent = old;
      if (c.ftop) c.ftop.textContent = old;
      if (c.fbottom) c.fbottom.textContent = val;

      c.card.classList.remove('flip');
      void c.card.offsetWidth;
      c.card.classList.add('flip');
      c.cur = val;

      var card = c.card,
        bottom = c.bottom,
        ftop = c.ftop;
      clearTimeout(c._t);
      c._t = setTimeout(function () {
        card.classList.remove('flip');
        if (bottom) bottom.textContent = val;
        if (ftop) ftop.textContent = val;
      }, FLIP_MS);
    }
  }

  customElements.define('sht-flip-countdown', FlipCountdown);
})();
